module.exports = require("core-js-pure/features/symbol");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/symbol.js
// module id = 229
// module chunks = 0 1